import React, { ReactNode } from 'react';
import { useField } from 'formik';
import HBBaseFormField, {
    HBBaseFormFieldProps
} from '../HBBaseFormField/HBBaseFormField';

interface Props extends Omit<HBBaseFormFieldProps, 'error' | 'errorMessage'> {
    /** The input element rendered inside the field wrapper. The consumer is responsible for wiring value and onChange to Formik state. */
    children: ReactNode;
    /** Enables DS Next visual styling (updated disabled colors and alignment). Temporary — will be removed post-migration. @deprecated */
    isDSNext?: boolean;
}

const HBFormField = (props: Props) => {
    const [, { error }] = useField(props.id);

    return <HBBaseFormField {...props} error={!!error} errorMessage={error} />;
};

export default HBFormField;
